<template>
  <!--  <lazy-dom>-->
  <div class="policy-form">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">

      <div class="box border-none">
        <template v-if="isCreate">
          <h3>Policyholder Details</h3>
          <div class="form-item">
            <el-form-item
              ref="is_guest"
              :rules="isEdit?[]:rules.select"
              prop="is_guest">
              <v-radio-group
                v-model="formData.is_guest"
                button
                :list="customerTypeOptions">
              </v-radio-group>
            </el-form-item>
          </div>
          <div
            v-if="formData.is_guest==1"
            class="flex-align-center mg-b-20">
            <div class="circle-container">
              <span class="circle-icon">
                <font-awesome-icon
                  class="fs-14"
                  icon="exclamation"></font-awesome-icon>
              </span>
            </div>
            <span>
              <p class="fw-600 fs-14 color-dark">Purchases made as a guest cannot enjoy member rewards and policy management functions.  
                If there's a referrer, they still receive the referrer reward.</p>
            </span>
          </div>
        </template>
        <h3>Policyholder Details</h3>
        <policy-holder
          v-if="isAttachCustomer||isFina||formData.is_guest==1||isRenewFinaToHc"
          ref="policy-holder"
          is-new-sme
          :is-fina="isFina||formData.is_guest==1"
          :is-uppercase="isCAR"
          :form="formData"
          :formDataLock="cusFormDataLock"
          :disabled="!isFina&&formData.is_guest!=1"
          :isEdit="isEdit"
          :form-data-lock="formDataLock"
          @getFormData="getSubimitForm"></policy-holder>
        <template v-if="!isQuote&&!isFina&&formData.is_guest==0">
          <template v-if="!isAttachCustomer">
            <div class="flex-align-center mg-b-20">
              <span class="circle-icon">
                <font-awesome-icon
                  class="fs-14"
                  icon="exclamation"></font-awesome-icon>
              </span>
              <span>
                <p class="fw-600 fs-14 color-dark">{{form.isrd_com_nm}} Company</p>
                <p class="fw-400 fs-14 color-dark">{{form.email}}</p>
              </span>
            </div>
            <el-form-item
              ref="customer_id"
              prop="customer_id"
              :rules="isCreate&&isNext?rules.select:null">
              <v-button
                icon="plus"
                green
                @click="handleAddCustomer">
                Attach Customer
              </v-button>
            </el-form-item>
          </template>
          <v-button
            v-else
            class="mg-t-20"
            blue
            icon="pen"
            @click="handleAddCustomer">
            Change Policyholder
          </v-button>
        </template>
      </div>

      <div class="box policy-content">
        <h3>Business Information</h3>
        <div
          class="form-item form-item__raido"
          :class="{'w-fill':isCAR}">
          <span>Type</span>
          <el-form-item
            ref="class_id"
            :rules="isEdit?[]:rules.select"
            prop="class_id">
            <v-radio-group
              v-model="formData.class_id"
              border
              :list="isCAR?newSmeCARProductOption:newSmeProductOption">
              <template
                slot-scope="{ item }"
                name="extra">
                <span>
                  <span><font-awesome-icon :icon="item.icon"></font-awesome-icon></span>
                  <span class="mg-l-5">{{item.name}}</span>
                </span>
              </template>
            </v-radio-group>
          </el-form-item>
        </div>
        <template v-if="!isCAR">
          <div
            class="form-item form-half">
            <span>Business Nature</span>
            <el-form-item
              v-if="formData.class_id!=89"
              ref="bus_nature"
              :rules="isEdit?[]:rules.select"
              :prop="isEdit?'':'bus_nature'"
            >
              <v-select
                v-model="formData.bus_nature"
                :list="SMENatureTime" />
            </el-form-item>
            <el-form-item
              v-else
              ref="bus_nature"
              :rules="isEdit?[]:rules.input"
              :prop="isEdit?'':'bus_nature'"
            >
              <v-input
                v-model="formData.bus_nature"
                key-non-chinese></v-input>
            </el-form-item>
          </div>
          <div class="form-item ">
            <span>Is it a newly established company?</span>
            <el-form-item
              ref="newly_com_ind"
              :rules="isEdit?[]:rules.select"
              prop="newly_com_ind">
              <v-radio-group
                v-model="formData.newly_com_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>What is sum insured of Contents? (including furniture, fixtures, fittings, machinery & equipment) </span>
            <el-form-item
              ref="contents_isrd"
              :rules="isEdit?{}:rules.sme_isrd"
              prop="contents_isrd">
              <v-input
                v-model="formData.contents_isrd"
                money
                :max="20000000"
                prepend="HK$" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span class="sme--content__tip ">
              Excludes articles brittle in nature / plate glass
            </span>
          </div>
          <div
            class="form-item form-half">
            <span>What is the sum insured of stock?</span>
            <el-form-item
              ref="stocks_isrd"
              :rules="isEdit?[]:rules.stocks_isrd"
              prop="stocks_isrd">
              <v-input
                v-model="formData.stocks_isrd"
                money
                :max="20000000"
                prepend="HK$"/>
            </el-form-item>
          </div>
          <div class="form-item">
            <span class="sme--content__tip ">
              Excludes stock of goods on consignment
            </span>
          </div>
          <div
            class="form-item form-half">
            <span>Sum Insured of Public Liability</span>
            <el-form-item
              ref="total_pl_isrd"
              :rules="isEdit?[]:rules.total_pl_isrd"
              prop="total_pl_isrd">
              <v-input
                v-model="formData.total_pl_isrd"
                :keyNumber="true"
                :int="true"
                prepend="HK$"/>
            </el-form-item>
          </div>
        </template>
        <template v-else>
          <div class="form-item">
            <span>Insured Name</span>
            <el-form-item
              ref="insured_name"
              :rules="isEdit?[]:rules.input"
              prop="insured_name">
              <v-input
                v-model="formData.insured_name"
                uppercase
                key-non-chinese></v-input>
            </el-form-item>
          </div>
        </template>
      </div>
      <div
        v-if="!isCAR"
        class="box">
        <div class="form-item">
          <el-form-item
            ref="employee_ind"
            :rules="isEdit?[]:rules.employee_ind"
            prop="employee_ind">
            <div class="flex-align-center">
              <h3 class="color-dark mg-b-0">Employee’s Compensation Details</h3>
              <div class="mg-l-15" >
                <v-checkbox
                  v-model="formData.employee_ind"
                  :is-boolean="false"
                  :select-number="1"
                  :no-number="2"></v-checkbox>
              </div>
            </div>
          </el-form-item>
        </div>
        <template v-if="formData.employee_ind==1">
          <occuption-underwriting
            ref="occuption"
            is-new-sme
            :employee-ind="formData.employee_ind"
            :isEdit="isEdit"
            :classId="formData.class_id"
            :form="form"></occuption-underwriting>
        </template>
      </div>
      <div
        v-else
        class="box">
        <h3>Work Details</h3>
        <div class="form-item ">
          <span>Contract Work</span>
          <el-form-item
            ref="contract_work"
            :rules="isEdit?[]:rules.input"
            prop="contract_work">
            <v-input
              v-model="formData.contract_work"
              uppercase
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <!--        <h3>Insured Details</h3>-->
        <div class="form-item form-half">
          <span>Name of Contractor</span>
          <el-form-item
            ref="nm_of_contractor"
            :rules="isEdit?[]:rules.input"
            prop="nm_of_contractor">
            <v-input
              v-model="formData.nm_of_contractor"
              uppercase
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Name of Landlord</span>
          <el-form-item
            ref="nm_of_landlord"
            :rules="isEdit?[]:rules.carSelect"
            :show-message="false"
            prop="nm_of_landlord">
            <v-input
              v-model="formData.nm_of_landlord"
              uppercase
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Name of Tenant</span>
          <el-form-item
            ref="nm_of_tenant"
            :rules="isEdit?[]:rules.carSelect"
            prop="nm_of_tenant">
            <v-input
              v-model="formData.nm_of_tenant"
              uppercase
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Name of Property Management Company</span>
          <el-form-item
            ref="nm_of_property"
            prop="nm_of_property">
            <v-input
              v-model="formData.nm_of_property"
              uppercase
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <div class="form-item ">
          <span>Contract Site</span>
          <el-form-item
            ref="contract_site"
            :rules="isEdit?[]:rules.input"
            prop="contract_site">
            <v-input
              v-model="formData.contract_site"
              uppercase
              :rows="2"
              type="textarea"
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <!--        <div-->
        <!--          class="flex-1">-->
        <!--          <div-->
        <!--            class="has-bold"-->
        <!--          >-->
        <!--            <div>-->
        <!--              <span class="title fs-16 color-dark fw-600">Contract Site</span>-->
        <!--              <address-form-->
        <!--                ref="cont-address-form"-->
        <!--                :isRequired="isRequired"-->
        <!--                :formType="1"-->
        <!--                :formDataLock="formDataLock"-->
        <!--                :is-uppercase="isCAR"-->
        <!--                :form="contAddress"-->
        <!--                @getFormData="getSubContractFormData" />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="form-item form-half">
          <span>Period of Insurance</span>
          <el-form-item
            ref="date"
            :rules="isEdit?[]:rules.select"
            prop="date">
            <v-date-picker
              v-model="formData.date"
              :clearable="true"
              type="daterange"
            />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Maintenance Period</span>
          <el-form-item
            ref="main_date"
            :rules="isEdit?[]:rules.select"
            prop="main_date">
            <v-date-picker
              v-model="formData.main_date"
              :clearable="true"
              type="daterange"
            />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Contract Value</span>
          <el-form-item
            ref="contract_val"
            :rules="isEdit?[]:rules.input"
            prop="contract_val">
            <v-input
              v-model="formData.contract_val"
              prepend="HK$"
              key-non-chinese
              money
            />
          </el-form-item>
        </div>
        <h3>Coverage</h3>
        <div class="form-item form-half">
          <span>{{isCAR?'Material Damage (Section 1)':'Section I (Material Damage)'}}</span>
          <el-form-item
            ref="materials_ind"
            :rules="isCAR?rules.carCoverageSelect:(isEdit?[]:rules.select)"
            :show-message="isCAR?false:true"
            prop="materials_ind">
            <v-radio-group
              v-model="formData.materials_ind"
              :list="isCAR?smeRequiredOptions:smeYesNoOptions"
            />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>{{isCAR?'Third-Party Liability (Section 2)':'Section II (Public Liability)'}}</span>
          <el-form-item
            ref="pl_isrd"
            :rules="isCAR?rules.carCoverageSelect:(isEdit?[]:rules.select)"
            :show-message="isCAR?false:true"
            prop="pl_isrd">
            <v-select
              v-model="formData.pl_isrd"
              :list="sme_contractor_pl_list"
            />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>{{isCAR?'Employee’s Compensation (Section 3)':'Section III (Employee Compensation)'}}</span>
          <el-form-item
            ref="employee_ind"
            :rules="isCAR?rules.carCoverageSelect:(isEdit?[]:rules.select)"
            prop="employee_ind">
            <v-radio-group
              v-model="formData.employee_ind"
              :list="isCAR?smeRequiredOptions:smeYesNoOptions"
            />
          </el-form-item>
        </div>
      </div>
      <div class="travel-box box sme-container__info">
        <h2>Upload Document</h2>
        <div>
          <div class="flex flex-sb-center">
            <div
              v-if="!isCAR"
              class="form-item form-half">
              <span>Renewal Notice or 3rd Party Quotation</span>
              <el-form-item
                ref="renew_file_id"
                :rules="rules.upload"
                prop="renew_file_id">
                <file-container
                  :fileData="formData.renew_file"
                  :edit="true"
                  is-show-detail
                  :show-left-name="false"
                  is-none-name
                  :is-viewer="true"
                  :file-list="fileList"
                  :otherData="{
                    idKey:'renew_file_id',
                    target: 'renew_file',
                    type:'renew_file'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerDeleteFile"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Business Registration Certificate</span>
              <el-form-item
                ref="br_file_id"
                :rules="rules.upload"
                prop="br_file_id">
                <file-container
                  :fileData="formData.br_file"
                  :edit="true"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  :file-list="fileList"
                  :otherData="{
                    idKey:'br_file_id',
                    target: 'br_file',
                    type:'br_files'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerDeleteFile">
                </file-container>
              </el-form-item>
            </div>
            <div
              v-if="isCAR"
              class="form-item form-half">
              <span>Contract</span>
              <el-form-item
                ref="contract_file_id"
                :rules="isEdit?[]:rules.upload"
                prop="contract_file_id">
                <file-container
                  :fileData="formData.contract_file"
                  :edit="true"
                  is-show-detail
                  :show-left-name="false"
                  is-none-name
                  :is-viewer="true"
                  :file-list="fileList"
                  :otherData="{
                    idKey:'contract_file_id',
                    target: 'contract_file',
                    type:'contract_file'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerDeleteFile"
                />
              </el-form-item>
            </div>
          </div>

        </div>
        <div class="table">
          <div class="th">{{isCAR?'Others / Supporting Doc':'Latest 3 months Contribution Record'}}</div>

          <div
            v-for="(item, index) in formData.mpf_files"
            :key="index"
            class="tr">
            <file-container
              :key="index"
              :edit="true"
              is-table
              :fileData="item"
              :file-list="fileList"
              :otherData="{
                index,
                target: 'mpf_files',
                type:'mpf_files'
              }"
              titleName= "MPF Documents"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
          </div>
          <div
            v-if="formData.mpf_files.length<=0"
            class="tr">-</div>
        </div>
        <el-form-item
          ref="mpf_files"
          prop="mpf_files">
          <v-upload
            label="Add File"
            icon="plus"
            blue
            :file-list="fileList"
            :otherData="{
              target: 'mpf_files',
              type:'mpf_files'
            }"
            @uploadSuccess="handlerUploadSuccess" />
        </el-form-item>
      </div>
      <div class="box">
        <h3>Internal Summary</h3>
        <div class="form-item ">
          <el-form-item
            ref="inter_summary"
            prop="inter_summary">
            <v-input
              v-model="formData.inter_summary"
              :rows="4"
              type="textarea"
              key-non-chinese></v-input>
          </el-form-item>
        </div>
      </div>

    </el-form>
    <attach-user
      ref="attach-user"
      :ticketId="ticketId"
      :isNewSME="true"
      is-share
      @shareUser="handleAttach"
    />
    <confirm-information
      ref="confirm-information"
      :upd_def_info="formData.updDefInfo"
      @confirm="handlerConfirmChangeInfo" />
  </div>
<!--  </lazy-dom>-->
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import PolicyHolder from '@/views/quoting/sme/component/policy-holder-form'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import {mapState} from 'vuex'
import {smeClassId} from '@/utils/smePath'
import OccuptionUnderwriting from './occuption-form'
import {SMEAttachedCustomer,editSMETicket} from '@api/new_sme'
import ConfirmInformation from '@/views/components/dialogs/confirm-information'
// import AddressForm from '@/views/components/address-form'
import MixinSame from '@/mixins/same'

export default {
  name: 'smeKycForm',
  components: {
    OccuptionUnderwriting,
    PolicyHolder,
    AttachUser,
    ConfirmInformation,
    // AddressForm,
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: ()=>({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    isNext: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const checkCarSelect = (rule, value, callback) => {

      let {nm_of_landlord,nm_of_tenant} = this.formData||{}
      if(!nm_of_landlord&&!nm_of_tenant) {
        callback( new Error('Fill in at least one of the contents') )
      }
      callback()
    }
    const checkSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const target = field_arr[0]
      const val = field_arr[1]
      let selectVal = this.formData[target][val]
      if(selectVal<=0) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const checkDateSelect = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData.policy_detail||{}
      if(!pcy_cmnt_dt) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const needAttach = (rule, value, callback) => {
      let {customer_id} = this.formData||{}
      if(customer_id<=0) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const needUpload = (rule, value, callback) => {
      //"beauty , Hair Salon, Medical Center
      let need = [84,86,88].includes(this.classId)
      let {device_files=[]} = this.formData.upload_document
      if(device_files.length<=0&&need) {
        callback( new Error(this.$t('placeholder.upload') ) )
      }
      callback()
    }
    const checkSelectTime = (rule, value, callback) => {
      let startTime = this.startTime
      let endTime = this.endTime
      if(!startTime||!endTime) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const checkSmeIsrd = (rule, value, callback) => {
      let {contents_isrd,stocks_isrd,total_pl_isrd,employee_ind} = this.formData||{}
      if((!contents_isrd||contents_isrd<=0) &&(!stocks_isrd||stocks_isrd<=0) &&(!total_pl_isrd||total_pl_isrd<=0)&&employee_ind==2) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const checkCARCoverageSelect = (rule, value, callback) => {
      let {materials_ind,pl_isrd,employee_ind} = this.formData||{}
      if(materials_ind==2&&employee_ind==2&&pl_isrd==0&&!pl_isrd) {
        callback( new Error('At least one of the three needs to be selected') )
      }
      callback()
    }
    return {
      showSMS:false,
      is_first:true,
      oldFormDataLock: -1,
      cusFormDataLock: 0,
      formParams:{},
      formData: {
        is_guest:0,
        less_verify_save: 0, // 是否僅保存部分資料（1：部分保存；0：全部保存   --标记是create 还是 edit
        newly_com_ind:'',
        isrd_com_nm:'',
        id_no:'',
        phone_no:'',
        email:'',
        bsns_nature_id:'',

        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',

        corr_address:{
          addr_room: '',
          addr_floor: '',
          addr_block: '',
          addr_building: '',
          addr_street: '',
          addr_district: '',
          addr_area: '',
          addr_region: '',
        },
        contact_nm:'',
        contact_phone:'',

        bus_nature:'',
        contents_isrd:'',
        stocks_isrd:'',
        total_pl_isrd:'',
        employee_ind:2,
        class_id:'',
        br_file:null,
        br_file_id:'',
        renew_file:null,
        renew_file_id:'',
        mpf_files:[],
        customer_id:'',

        insured_name:'',
        contract_work:'',
        contract_file:null,
        contract_file_id:'',
        date:[],
        main_date:[],
        contract_val:'',
        materials_ind:1,
        pl_isrd:'',
        cont_addr_room:'',
        cont_addr_floor:'',
        cont_addr_block:'',
        cont_addr_building:'',
        cont_addr_street:'',
        cont_addr_district:'',
        cont_addr_area:'',
        cont_addr_region:'',

        contract_site:'',
        nm_of_property:'',
        nm_of_tenant:'',
        nm_of_landlord:'',
        nm_of_contractor:'',
        inter_summary:'',
      },
      subForm: {
        'policy-holder': false,
        // 'cont-address-form':false
      },
      rules: {
        contents_isrd: [
          {validator: checkSmeIsrd,message: this.$t('placeholder.input'), trigger: ['blur','change'] },
        ],
        stocks_isrd: [
          {validator: checkSmeIsrd,message: this.$t('placeholder.input'), trigger: ['blur','change'] },
        ],
        total_pl_isrd: [
          {validator: checkSmeIsrd,message: this.$t('placeholder.input'), trigger: ['blur','change'] },
        ],
        employee_ind: [
          {validator: checkSmeIsrd,message: this.$t('placeholder.select'), trigger: ['blur','change'] },
        ],
        timeRequired: [
          {validator: checkDateSelect,message: this.$t('placeholder.select'), trigger: ['blur','change'] },
        ],
        smeSelect: [
          {validator: checkSelect,message: this.$t('placeholder.select'), trigger: ['blur','change',] },
        ],
        select_time: [
          {validator: checkSelectTime,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
        ],
        document_upload:[
          {validator: needUpload,message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] },
        ],
        customer_id:[
          {validator: needAttach,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
        ],
        carSelect:[
          {validator: checkCarSelect, trigger: ['change', 'blur'] },
        ],
        carCoverageSelect:[
          {validator: checkCARCoverageSelect, trigger: ['change', 'blur'] },
        ]
      },

    }
  },
  computed: {
    ...mapState('smeQuote', ['smeQuickForm']),
    isCARCoverage(){
      let {materials_ind,pl_isrd,employee_ind} = this.formData||{}
      return materials_ind==1||employee_ind==1||pl_isrd>0
    },
    isRenewFinaToHc(){
      let {type,customer_id,is_guest_order} = this.form||{}
      return customer_id<=0&&is_guest_order!=1
    },
    carValid(){
      let {nm_of_landlord,nm_of_tenant} = this.formData||{}
      return nm_of_landlord||nm_of_tenant
    },
    sme_contractor_pl_list(){
      let {sme_car_contractor_pl,sme_contractor_pl} = this.globalOptions||{}
      return this.isCAR?sme_car_contractor_pl:sme_contractor_pl
    },
    SMENatureTime(){
      let {class_id=81} = this.formData||{}
      return this[`SMENatureTime_${class_id}`]
    },
    SMEJobRoleOption(){
      let {class_id=81} = this.formData||{}
      return this[`SMEJobRoleOption_${class_id}`]
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    type(){
      let {type} = this.$route.params
      return type
    },
    orderId(){
      let {order_id} = this.$route.query||{}
      return order_id
    },
    isCAR(){
      let {classId} = this.$route.params
      let {class_id,product_id} = this.form||{}
      return product_id==81||classId==79||class_id==79
    },
    isAttachCustomer(){
      let {customer_id}=this.formData||{}
      return customer_id>0||this.isFina
    },
    policyholder_detail(){
      let {policyholder_detail={}} =this.form||{}
      return policyholder_detail||{}
    },
    isRules(){
      return this.checkRefer ===2
    },
    isrdValid(){
      let {contents_isrd,total_pl_isrd,employee_ind,stocks_isrd} = this.formData||{}
      if((!contents_isrd||contents_isrd<=0)&&(!stocks_isrd||stocks_isrd<=0)&&(!total_pl_isrd||total_pl_isrd<=0)&&employee_ind==2) {
        return true
      }
      return false
    },
    contAddress(){
      let {cont_addr_room,cont_addr_floor,cont_addr_block,cont_addr_building,cont_addr_street,cont_addr_district,cont_addr_area,cont_addr_region} =  this.formData||{}
      return{
        addr_room:cont_addr_room,
        addr_floor:cont_addr_floor,
        addr_block:cont_addr_block,
        addr_building:cont_addr_building,
        addr_street:cont_addr_street,
        addr_district:cont_addr_district,
        addr_area:cont_addr_area,
        addr_region:cont_addr_region
      }
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep:true,
      handler(val) {
        if (val) {
          // if(this.formDataLock !== this.oldFormDataLock) {
          //   // 觸發更新就賦值，避免二次更新
          //   this.oldFormDataLock = this.formDataLock
          let {contractor_data={},referrer_id,code,referrer_user_id,referrer,is_guest_order} = val||{}
          let {pcy_cmnt_dt,pcy_expry_dt,main_start_dt='',main_end_dt=''} = contractor_data||{}
          if(pcy_cmnt_dt&&pcy_expry_dt)
            this.formData.date = [pcy_cmnt_dt,pcy_expry_dt]
          if(main_start_dt&&main_end_dt)
            this.formData.main_date = [main_start_dt,main_end_dt]
          if(this.isCAR&&this.isRefer){
            this.formData = {...val,...this.formData,...contractor_data,referrer_id}
          }
          Object.keys(this.formData).some(key => {
            if (key in val) {
              this.formData[key] = JSON.parse(JSON.stringify(val[key]))
            }
            // if(key in contractor_data && this.isCAR){
            //   this.formData[key] = JSON.parse(JSON.stringify(contractor_data[key]))
            // }
            if(this.isCAR){
              let {employee_ind=1,materials_ind=1,pl_isrd,pl_ind} = val||{}
              this.formData.employee_ind = employee_ind
              this.formData.materials_ind =materials_ind
              this.formData.pl_isrd =pl_isrd
            }
          })
          this.formData.is_guest = is_guest_order||0
          if(this.isRefer){
            this.formData = {...this.formData,referrer_id,referrer_user_id,referrer}
          }
          let {contents_isrd,stocks_isrd,total_pl_isrd} = val||{}
          if(contents_isrd<=0)  this.formData.contents_isrd  =0
          if(stocks_isrd<=0)  this.formData.stocks_isrd  =0
          if(total_pl_isrd<=0)  this.formData.total_pl_isrd  =0
        }
        let {
          addr_room,
          addr_floor,
          addr_block,
          addr_building,
          addr_street,
          addr_district,
          addr_area,
          addr_region} = val||{}
        this.formData.corr_address = {
          addr_room,
          addr_floor,
          addr_block,
          addr_building,
          addr_street,
          addr_district,
          addr_area,
          addr_region
        }
        // }
      }
    },
    isrdValid:{
      immediate:true,
      deep:true,
      handler(val){
        this.$nextTick(()=>{
          if(this.$refs.form){
            if(val&&!this.is_first){
              this.$refs.form.validateField(['contents_isrd','total_pl_isrd','stocks_isrd','employee_ind'])
            }
            else  {
              this.$refs.form.clearValidate(['contents_isrd','total_pl_isrd','stocks_isrd','employee_ind'])
              this.is_first = false
            }

          }
        })
      }
    },
    carValid:{
      immediate:true,
      handler(val){
        if(val&&!this.is_first){
          this.$refs.form.clearValidate(['nm_of_landlord','nm_of_tenant'])
        }
        if(!val&&!this.is_first){
          this.$refs.form.validateField(['nm_of_landlord','nm_of_tenant'])
        }
      }
    },
    isCARCoverage:{
      immediate:true,
      handler(val){
        if(val&&!this.is_first){
          this.$refs.form.clearValidate(['materials_ind','pl_isrd','employee_ind'])
        }
        if(!val&&!this.is_first){
          this.$refs.form.validateField(['materials_ind','pl_isrd','employee_ind'])
        }
      }
    },
  },
  created() {
  },
  methods: {
    getSubContractFormData(form, data) {
      this.subForm[form] = true
      Object.keys(data).some((key)=>{
        this.formData[`cont_${key}`] = data[key]
      })
    },
    handlerConfirmChangeInfo(result,params) {
      if (result) {
        this.formParams.upd_def_addr = 1 // 標記需要更新常置資料
      }
      this.$emit('getFormData', this.formParams)
    },
    handleAttach(id,data){
      this.network().SMEAttachedCustomer({customer_id:id})
    },
    handleAddCustomer(){
      this.$refs['attach-user'].showAttachCustomer()
    },
    handleChange(val,name) {
      this[name] = val
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form||{}
      return disable_filed.includes(field)&&this.form[field]!=''
    },
    async  lessSubmitForm(otherData = {}){
      this.otherData = otherData
      let {policy_detail={},employee_ind,is_guest} = this.formData
      let {same_as_corr_addr_ind} = policy_detail
      let subForm = this.subForm
      if(!this.isAttachCustomer&&is_guest!=1){
        delete subForm['policy-holder']
      }
      if(employee_ind==2||this.isCAR){
        delete subForm['occupation']
      }
      // if(!this.isCAR)
      //   delete subForm['cont-address-form']
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      let data = {}
      if(employee_ind==1&&!this.isCAR){
        data = await this.$refs.occuption.subimitLessForm()
      }
      let result = {
        ...this.formData,
        ...data
      }
      if(this.isCAR){
        let {date,main_date} = this.formData
        result = {
          ...result,
          pcy_cmnt_dt:date[0],
          pcy_expry_dt:date[1],
          main_start_dt:main_date[0],
          main_end_dt:main_date[1],
        }
      }
      this.$emit('getFormData', result, otherData)

    },
    submitForm(otherData = {}) {
      let subForm = this.subForm
      // if(!this.isCAR)
      //   delete subForm['cont-address-form']
      this.$refs['form'].validate(async(valid, rules) => {
        if(valid) {
          let {is_guest} = this.formData||{}
          if(this.isAttachCustomer||is_guest==1||this.isRenewFinaToHc){
            Object.keys(subForm).some(key => {
              subForm[key] = false
              this.$refs[key].submitForm(key)
            })
            if(Object.values(this.subForm).some(item => item === false)) {
              return
            }
          }
          let {employee_ind} = this.formData
          let data = {}
          if(employee_ind==1&&!this.isCAR){
            data = await this.$refs.occuption.submitForm()
          }
          let result = {
            ...this.formData,
            ...data,
            save_request:this.isEdit?0:1
          }
          if(this.isCAR){
            let {date,main_date} = this.formData
            result = {
              ...result,
              pcy_cmnt_dt:date[0],
              pcy_expry_dt:date[1],
              main_start_dt:main_date[0],
              main_end_dt:main_date[1],
            }
          }
          const {updDefInfo = []} = this.formData
          this.formParams = result
          if (updDefInfo && updDefInfo.length > 0&&!this.isFina&&is_guest==0) {
            this.$refs['confirm-information'].changeDialog()
          } else {
            this.handlerConfirmChangeInfo()
          }
          // this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSubimitForm(form, data) {
      // debugger
      this.subForm[form] = true
      let {corr_address} =data||{}
      this.formData = {
        ...this.formData,
        ...data,
        ...JSON.parse(JSON.stringify(corr_address))
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      if(target !== 'mpf_files') {
        this.$set(this.formData,target,data)
        this.$set(this.formData,idKey,id)
      }
      else {
        this.formData[target].push(data)
      }
    },
    handlerDeleteFile(otherData) {
      let { type, index,target,idKey} = otherData
      if(target !== 'mpf_files') {
        this.formData[target]={}
        this.formData[idKey]=''
      }else {
        this.formData[target].splice(index,1)
      }
    },

    network(){
      return{
        SMEAttachedCustomer: async ({customer_id}) => {
          const {data} = await SMEAttachedCustomer({
            customer_id,
            ticket_id:this.ticketId
          })
          let {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region} = data||{}
          let corr_address = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          this.formData = {
            ...this.formData,
            ...data,
            corr_address,
            customer_id
          }
          this.cusFormDataLock += 1
        },

      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
/deep/.policy-form{
  width: 690px!important;
}
.policy-form{
  width: 690px!important;
  max-width: 690px;
  .box {
    padding-bottom: 15px;
    margin-bottom: 30px;
    border-bottom:1px solid #D1D5DA;;
    &.border-none{
      border-bottom: 0;
    }
    .circle-container{
      margin-right: 8px;
      width: 18px;
      height: 18px;
    }
    .circle-icon{
      margin-right: 8px;
      width: 18px;
      height: 18px;
      border-radius: 30px;
      background: #D73A49;
      display: flex;
      color: white;
      font-weight: 600;
      justify-content: center;
      align-items: center;
    }
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
  .gray{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    display: inline-block;
  }
}
/deep/ .max-content{
  width: max-content;
}
.select-time{
  .el-date-editor{
    width: 100%;
  }
}
.form-item{
  .sme--content__tip{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #586069;
    padding-bottom: 0;
  }
  >span{
    &:first-child {
      display: block;
      padding-bottom: 8px;
    }
  }
  &.form-item__raido{
    /deep/.el-radio-group{
      .el-radio{
        width: calc(50% - 10px);
        margin-left: 0;
        margin-bottom: 8px;
      }
    }
    &.w-fill{
      /deep/.el-radio-group{
        .el-radio{
          width: 100%;
        }
      }
    }
  }
}
.table{
  .th{
    font-size: 14px;
    padding: 8px 16px!important;
  }
  .tr{
    display: flex;
    justify-content: space-between;
    padding:10px 16px;
    span{
      flex: none;
    }
    .blue {
      color: #409EFF!important;
    }
  }
}
.mg-b-0{
  padding-bottom: 0;
}
</style>
